<span [ngbTooltip]="property" [openDelay]="500">{{ property }}</span>
